module.exports = "function setVideoJS() {\n\n    document.querySelectorAll(\".video-js\").forEach(element => {\n        videojs(element);\n    });\n\n}"